import { z } from 'my-zod'
import { rideInformationFragment } from './ride-information-fragment'
import { modelFamiliesModel } from '../../fleet-operations/model-family'

export const rideInformationInviteGuestView = rideInformationFragment.augment({
  customerId: z.string().uuid(),
  customerOrderShortId: z.string().nullish(),
  shortId: z.string().nullish(),

  productId: z.string().uuid().nullish(),
  productVersionId: z.number().nullish(),
  modelFamilyName: modelFamiliesModel.shape.modelFamilyName.nullish()
})

export type rideInformationInviteGuestView = z.infer<typeof rideInformationInviteGuestView>
